// extracted by mini-css-extract-plugin
export default {"footerContainer":"footer_footerContainer__NQYgC","footer":"footer_footer__PyWg3","footerText":"footer_footerText__EOQhh","footerIcon":"footer_footerIcon__vTJjE"};